export async function imagePreview(blob: Blob): Promise<string | undefined> {
  if (!["image/png", "image/jpeg"].includes(blob.type)) return undefined;
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => typeof reader.result === "string" ? resolve(reader.result) : reject(new Error("Etiket görseli okunamadı."));
    reader.onerror = () => reject(new Error("Etiket görseli okunamadı."));
    reader.readAsDataURL(blob);
  });
}
